import { adminTypes } from "@admin/admin-types.di";
import type { AdminRepository } from "@admin/domain/repositories/admin.repository";
import { SpatialLevelsResume } from "@station/domain/models/spatial-level-resume.model";
import { inject, injectable } from "inversify";

@injectable()
export class SpatialLevelsResumeGetByStationIdUseCase {
    constructor(
        @inject(adminTypes.repositories.AdminRepository)
        private readonly adminRepository: AdminRepository,
    ) {}

    async execute(stationId: string): Promise<SpatialLevelsResume> {
        const spatialLevelsResumeResult =
            await this.adminRepository.getSpatialLevelsResumeByStationId(
                stationId,
            );

        if (spatialLevelsResumeResult.isErr()) {
            throw new Error("Error getting spatial levels");
        }

        return spatialLevelsResumeResult.match(
            (spatialLevels) => spatialLevels,
            () => SpatialLevelsResume.empty(),
        );
    }
}
